import { render, staticRenderFns } from "./LinePermissionSelect.vue?vue&type=template&id=f4986b16&scoped=true&"
import script from "./LinePermissionSelect.vue?vue&type=script&lang=js&"
export * from "./LinePermissionSelect.vue?vue&type=script&lang=js&"
import style0 from "./LinePermissionSelect.vue?vue&type=style&index=0&id=f4986b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4986b16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSelect})
